<template>
  <div>
    <v-card
      class="mx-4 my-4 shadow card-radius dashboard-card-css white"
      :height="$vuetify.breakpoint.sm || $vuetify.breakpoint.xs ? '' : '320px'"
      :class="isMac ? 'edited_scrollbar' : ''"
    >
      <v-card-title>
        <v-col class="font-size-18 font-weight-bold dark-purple-text" cols="12">
          <span class="font-size-18 font-weight-bold dark-purple-text">
            Top Tasks
          </span>
          <v-menu
            v-model="topTaskOptionsMenu"
            :close-on-content-click="false"
            offset-y
            rounded
            content-class=" bg-color"
            min-width="50"
          >
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                v-bind="attrs"
                v-on="on"
                color="#2a206a"
                class="text-capitalize ml-2 float-right"
                small
                outlined
                max-width="90"
                style="border-radius: 2px"
              >
                {{ topTasksCount ? "View" + " " + topTasksCount : "View All" }}
                <v-icon small class="pl-1"> mdi-chevron-down </v-icon>
              </v-btn>
            </template>
            <div :class="isMac ? 'edited_scrollbar' : ''">
              <v-list
                max-height="200"
                class="pointer overflow-scroll"
                width="100px"
              >
                <div
                  v-for="value in topTasksOptions"
                  :key="value"
                  class="status-list-min-height caption listing-hover d-flex pointer"
                  :class="topTasksCount == value ? 'bg-selected' : ''"
                >
                  <v-list-item-content @click="topTasksCount = value">
                    <span class="ml-2 text-capitalize">
                      {{ value }}
                    </span>
                  </v-list-item-content>
                </div>
                <div
                  class="status-list-min-height caption listing-hover d-flex pointer"
                  :class="!topTasksCount ? 'bg-selected' : ''"
                >
                  <v-list-item-content @click="topTasksCount = null">
                    <span class="ml-2 text-capitalize"> All </span>
                  </v-list-item-content>
                </div>
              </v-list>
            </div>
          </v-menu>
        </v-col>
      </v-card-title>
      <v-card-text>
        <v-row>
          <v-col class="mx-3">
            <!-- skeleton loader for top tasks -->
            <v-skeleton-loader
              tile
              v-if="getDashboardLoaders.topTasks"
              height="200"
              type="table-tbody"
            ></v-skeleton-loader>
            <v-data-table
              v-else
              :headers="headers"
              :items="
                topTasksCount && getTopTasks
                  ? getTopTasks.slice(0, topTasksCount)
                  : getTopTasks
              "
              height="230"
              class="elevation-0 theme-border mt-n3 top-projects-table"
              disable-pagination
              fixed-header
              mobile-breakpoint="0"
              :class="isMac ? 'edited_scrollbar' : ''"
              hide-default-footer
            >
              <template slot="no-data">
                <div
                  class="d-flex justify-center align-center mt-n1"
                  style="height: 170px"
                >
                  <div>
                    <!-- <div>
                      <v-icon size="40"> mdi-account-clock-outline </v-icon>
                    </div> -->
                    <div>No data found</div>
                  </div>
                </div>
              </template>
              <template v-slot:[`header.name`]="{ header }">
                <div class="dark-purple-text">
                  {{ header.text }}
                </div>
              </template>
              <template v-slot:[`header.project`]="{ header }">
                <div class="dark-purple-text">
                  {{ header.text }}
                </div>
              </template>
              <template v-slot:[`header.sum`]="{ header }">
                <div class="dark-purple-text font-weight-bold">
                  {{ header.text }}
                </div>
              </template>
              <template v-slot:[`header.status`]="{ header }">
                <div class="dark-purple-text">
                  {{ header.text }}
                </div>
              </template>
              <template v-slot:[`item.name`]="{ item }">
                <span
                  class="text-capitalize"
                  :class="!item.title ? 'grey--text font-italic' : ''"
                >
                  {{ item.title ? item.title : "No Title" }}
                </span>
              </template>
              <template v-slot:[`item.project`]="{ item }">
                <span
                  class="text-capitalize"
                  :class="!item.project_name ? 'grey--text font-italic' : ''"
                >
                  {{ item.project_name ? item.project_name : "No Project" }}
                </span>
              </template>
              <template v-slot:[`item.sum`]="{ item }">
                <span>
                  {{ item.duration }}
                </span>
              </template>
              <template v-slot:[`item.status`]="{ item }">
                <span class="text-capitalize">
                  {{
                    item.status == "active"
                      ? item.running
                        ? "Active"
                        : "Paused"
                      : item.status
                  }}
                </span>
              </template>
            </v-data-table>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import moment from "moment";
import { momentHelper } from "@/mixins/momentHelper.js";

export default {
  mixins: [momentHelper],
  data() {
    return {
      topTasksCount: null,
      topTaskOptionsMenu: false,
      topTasksOptions: ["3", "5"],
      headers: [
        {
          text: "Task Name",
          value: "name",
          sortable: false,
          class: "dashboard-table-bg",
        },
        {
          text: "Project Name",
          value: "project",
          class: "dashboard-table-bg",
          sortable: false,
        },
        {
          text: "Worked Hours",
          value: "sum",
          class: "dashboard-table-bg",
          sortable: false,
        },
        {
          text: "Task Status",
          value: "status",
          class: "dashboard-table-bg",
          sortable: false,
        },
      ],
    };
  },
  components: {
    // profileImage: () => import("@/components/Includes/ProfileImage"),
  },
  computed: {
    ...mapGetters([
      "getProject",
      "getDashboardFilters",
      "getTopProjects",
      "getDashboardDateFilter",
      "getTopTasks",
      "getDashboardLoaders",
      "getDashboardMember",
      "getDashboardStartDate",
    ]),
  },
  methods: {
    // Fetch top projects
    searchData() {
      this.$store.dispatch("fetchTopTasks");
    },
    // Dates calculation after date range (option) selection
    dateRange() {
      if (this.getDashboardDateFilter == "Today")
        return [moment().format("YYYY-MM-DD"), moment().format("YYYY-MM-DD")];
      if (this.getDashboardDateFilter == "Yesterday")
        return [
          moment().subtract(1, "day").format("YYYY-MM-DD"),
          moment().subtract(1, "day").format("YYYY-MM-DD"),
        ];
      if (this.getDashboardDateFilter == "Last 7 days")
        return [
          moment().subtract(6, "day").format("YYYY-MM-DD"),
          moment().format("YYYY-MM-DD"),
        ];
      if (this.getDashboardDateFilter == "Last 30 days")
        return [
          moment()
            .subtract(29, "day")

            .format("YYYY-MM-DD"),
          moment().format("YYYY-MM-DD"),
        ];
      if (this.getDashboardDateFilter == "This month") {
        return [
          moment().clone().startOf("month").format("YYYY-MM-DD"),
          moment().clone().endOf("month").format("YYYY-MM-DD"),
        ];
      }
      if (this.getDashboardDateFilter == "All time")
        return ["2000-01-01", moment().format("YYYY-MM-DD")];
      else return [];
    },
  },
  watch: {
    getDashboardStartDate() {
      this.searchData();
    },
    getDashboardMember(value, oldValue) {
      if (oldValue && value) this.searchData();
    },
  },
  mounted() {
    this.searchData();
  },
};
</script>
<style scoped>
.header-dropdown {
  border: 1px #2a206a solid !important;
  width: 100px;
}
.font-size-20 {
  font-size: 20px;
}
.top-projects-table {
  overflow: hidden;
}
</style>
